import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { LuArrowLeft, LuCircleCheck, LuClock, LuCircle } from 'react-icons/lu';
import TransporterLayout from '../../components/TransporterLayout/TransporterLayout';
import TripMap from '../../components/TripMap/TripMap';
import { fetchOrderTrail } from '../../lib/directus';
import { buildFallbackTrail, normalizeOrderTrail } from '../../lib/orderTrail';
import styles from './TransporterTripDetail.module.css';

export default function TransporterTripDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [trail, setTrail] = useState([]);
  const trip = location.state?.trip || {
    id: 1,
    loadRecordId: id || 1,
    orderId: null,
    loadId: '#LD-2024-5580',
    pickup: 'Accra',
    delivery: 'Tema',
    cargo: 'Maize (Grade A)',
    quantity: '50 MT',
    driver: 'John Doe',
    date: 'Feb 1 2026, 6:00 PM',
    earned: '$1,100',
    status: 'In transit',
    distance: '~45KM',
    estimatedTime: '1.5 hours',
  };
  const timelineItems = trail.length > 0
    ? trail
    : buildFallbackTrail(
        String(trip.status || '').toLowerCase().replace(/\s+/g, '_'),
        trip.date,
        'transport'
      );

  useEffect(() => {
    fetchOrderTrail({ orderId: trip.orderId, loadId: trip.loadRecordId || id })
      .then(data => setTrail(normalizeOrderTrail(data)))
      .catch(() => setTrail([]));
  }, [id, trip.loadRecordId, trip.orderId]);

  return (
    <TransporterLayout>
      <div className={styles.page}>
        {/* Back button */}
        <button className={`${styles.backBtn} d-flex justify-content-center align-items-center`} onClick={() => navigate('/trips')}>
          <LuArrowLeft size={16} />
        </button>

        <div className={styles.layout}>
          {/* Left panel */}
          <div className={styles.panel}>
            {/* Load ID + badge */}
            <div className={styles.panelTop}>
              <span className={styles.loadIdText}>{trip.loadId}</span>
              <span className={styles.inTransitBadge}>{trip.status}</span>
            </div>

            {/* Info sub-card */}
            <div className={styles.topCard}>
              <div className={styles.infoRow}>
                <span className={styles.infoLabel}>Distance &amp; Est time</span>
                <span className={styles.infoValue}>{trip.distance} • {trip.estimatedTime}</span>
              </div>
              <div className={styles.infoRow} style={{ borderBottom: 'none' }}>
                <span className={styles.infoLabel}>Driver</span>
                <span className={styles.infoValue}>{trip.driver}</span>
              </div>
            </div>

            {/* Cargo details sub-card */}
            <div className={styles.innerCard}>
              <p className={styles.subCardLabel}>Cargo details</p>
              <div className={styles.cargoRow}>
                <span className={styles.cargoLabel}>Commodity</span>
                <span className={styles.cargoValue}>{trip.cargo}</span>
              </div>
              <div className={styles.cargoRow}>
                <span className={styles.cargoLabel}>Quantity</span>
                <span className={styles.cargoValue}>{trip.quantity}</span>
              </div>
            </div>

            {/* Trip progress sub-card */}
            <div className={styles.bottomCard}>
              <p className={styles.subCardLabel}>Trip progress</p>
              <div className={styles.progressList}>
                {timelineItems.map((step) => {
                  const Icon = step.state === 'done' ? LuCircleCheck : step.state === 'active' ? LuClock : LuCircle;
                  const color = step.state === 'done'
                    ? 'var(--olive-color)'
                    : step.state === 'active'
                      ? 'var(--secondary-color)'
                      : '#d1d5db';
                  const labelClass = step.state === 'pending' ? styles.progressTextGray : styles.progressText;
                  return (
                    <div key={step.key} className={styles.progressStep}>
                      <Icon size={15} color={color} style={{ flexShrink: 0, marginTop: 2 }} />
                      <div>
                        <p className={labelClass}>{step.label}</p>
                        {!!step.meta && <p className={styles.progressSub}>{step.meta}</p>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Map */}
          <div className={styles.mapArea}>
            <TripMap pickup={trip.pickup} delivery={trip.delivery} />
          </div>
        </div>
      </div>
    </TransporterLayout>
  );
}
